import { render } from "./list.vue?vue&type=template&id=11a25c07&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=11a25c07&lang=scss&scoped=true"

import exportComponent from "/chaopin/jpom/data/build/66617637594a40d3882f98d9518ea655/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a25c07"]])

export default __exports__